import { Module } from 'wrapper6'
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

const $ = jQuery

export default class Sliders extends Module {
  ready (app) {
    this.productSliders = document.querySelectorAll('.mtt-product-slider')
    this.cartSliders = document.querySelectorAll('.cart-slider-outer')
    this.casesSliders = document.querySelectorAll('.mtt-cases-slider')
    this.linksliders = document.querySelectorAll('.mtt-link-slider')

    this.addSliders(this.productSliders, {
      spaceBetween: 16,
      breakpoints: {
        580: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        }
      }
    })

    this.addSliders(this.casesSliders, {
      spaceBetween: 38,
      breakpoints: {
        580: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 38
        }
      }
    })

    this.addSliders(this.cartSliders, {
      spaceBetween: 16,
      breakpoints: {
        700: {
          slidesPerView: 2
        }
      }
    })

    this.addSliders(this.linksliders, {
      spaceBetween: 16,
      breakpoints: {
        580: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3
        },
        1150: {
          slidesPerView: 4
        }
      }
    })
  }

  addSliders (sliders, options) {
    if (sliders.length) {
      for (let i = 0; i < sliders.length; i++) {
        const slider = sliders[i]

        const swiper = new Slider(slider, options)
      }
    }
  }
}

class Slider {
  constructor (slider, options) {
    this.slider = slider
    this.options = options

    this.addSlider()
  }

  addSlider () {
    const sliderContainer = this.slider.querySelector('.swiper-container')

    const swiper = new Swiper(sliderContainer, {
      slidesPerView: 1.3,
      watchOverflow: true,
      lazy: {
        loadPrevNext: true,
        checkInView: true
      },
      navigation: {
        nextEl: this.slider.querySelector('.arrow-button.next'),
        prevEl: this.slider.querySelector('.arrow-button.prev')
      },
      breakpoints: this.options.breakpoints,
      spaceBetween: this.options.spaceBetween
    })
  }
}
